console.log('app2.js loaded');
/* eslint-disable */
(function() {
    // Start of use strict
    "use strict";

    var probnaFunkcja = function () {
      console.log('dzialam');
    };

    var $window = $(window),
        $document = $(document),
        $navigation = $('#nav'),
        $sections = $('section'),
        $bodyHtml = $('body, html'),
        $navigationLinks = $('#nav ul a'),
        pageIsLoaded = false,
        navigationWidth = $navigation.outerWidth(),
        windowHeight = $window.height(),
        windowWidth = $window.width(),
        prevWindowWidth = 0,
        mobileNavigationOpened = false,
        scrollDownArrowVisible = true,
        pagePartPositions = [],
        offsetNavigation = 150,
        isMobileTouch = (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) && windowWidth < 1050,
        prev = $window.scrollTop();

    // on page load
    $window.on('load', function(){

      console.log('onload');
        onLoad();
    });

    // prevent scrolling until page loads
    document.addEventListener('touchmove', function (e) {
        if (!pageIsLoaded || mobileNavigationOpened) {
            e.preventDefault();
        }
    }, false);

    // some variables must by checked when device width is resized
    // and fixes layout
    var setLayouts = debounce(function() {

        navigationWidth = $navigation.outerWidth();
        windowHeight = $window.height();
        windowWidth = $window.width();

        // adapt full height elements if window width changed
        if (prevWindowWidth != windowWidth) {
            $('.header, #preload, #background').css({height: windowHeight});
            // center header text
            $('.header-center').css({marginTop: -$('.header-center').outerHeight() / 2 * 1.1});
        }

        // center "about" element
        //fixAboutSection();

        // check position of each part of a page (used to display active item
        // in navigation)
        checkPagePartPositions();

        // hidden offset element depends on screen width, so need to check its height
        offsetNavigation = $('#offset-element').height();

        // refresh grid to be sure they are displayed correctly
        $('.grid').each(function(){
            window.salvattore.recreateColumns(this);
        });

        // save for future
        prevWindowWidth = windowWidth;

    }, 250);

    // document ready function mostly used for init features
    $(function(){

        // removes click delays on browsers with touch UIs.
        FastClick.attach(document.body);

        // check layout issues
        setLayouts();

        // select element wich are used several times
        var videoEl = $('.section-video'),
            aboutEl = $('.section-about');

        // enables video background for video section
        if (videoEl.length && videoEl.attr('data-video')) {
            videoEl.vide({
                mp4: videoEl.attr('data-video'),
            }, {
                volume: 1,
                playbackRate: 1,
                muted: true,
                loop: true,
                autoplay: true,
                position: '50% 50%', // Similar to the CSS `background-position` property.
                posterType: 'jpg', // Poster image type. "detect" — auto-detection; "none" — no poster; "jpg", "png", "gif",... - extensions.
                resizing: true, // Auto-resizing, read: https://github.com/VodkaBears/Vide#resizing
                bgColor: 'transparent', // Allow custom background-color for Vide div,
                className: ''
            });
        }

        // enables autosizing for textarea field
        $('textarea:not(.autosized)').addClass('autosized').autosize();

        // clones content of about section
        // it is needed because one copy is hidden and section height (if device
        // height is too small) depends on it
        //aboutEl.append(aboutEl.html());

        // delays fade of the first item on page load
        var scrollRevealDelayOnLoad = 1400;

        // enables scroll reveal animations
        window.sr = ScrollReveal({
            duration: 800,
            useDelay: 'onload',
            delay: scrollRevealDelayOnLoad,
        }, 100);

        sr.reveal('.sr');
        sr.reveal('.sr-group-1', 300);
        sr.reveal('.sr-group-3', 300);
        sr.reveal('.sr-group-4', 300);

    });

    // bind setLayouts function on window resize
    $(window).resize(setLayouts);

    // on page load
    function onLoad() {
        // refresh grid to be sure they are displayed correctly
        $('.grid').each(function(){
            window.salvattore.recreateColumns(this);
        });

        // trigger scroll event to reveal elements that should be visable
        // when someone opened (or refreshes) a website
        $window.scroll();

        // delays fade of preloader a bit, because when page is loaded
        // second time preloader may be shown for a very short time and it looks
        // not nice. if you decide to set it to 0, then also change
        // value of scrollRevealDelayOnLoad
        var preloaderTimeout = 1000;

        // hide loader
        setTimeout(function(){
            $('#preload').fadeOut(300,function(){
                pageIsLoaded = true;
            });
        },preloaderTimeout);
    }

    // binds onscroll event
    $window.scroll(function(){
        onScroll();
    });

    // opens video
    $document.on('click','.js-open-video',function(e){
        // prevent page scroll top
        e.preventDefault();
        // if it is mobile touch device - open video in new window
        if (isMobileTouch) {
            var videoUrl = $('.section-video').attr('data-video');
            window.open(videoUrl);
        // open modal and start playing
        } else {
            openFullScreenVideo();
        }
    });

    // closes video
    $document.on('click','.js-close-video',function(e){
        closeFullScreenVideo();
    });

    // removes error class when typing input wich previously was validated
    $document.on('focus keyup','input, textarea',function(){
        $(this).removeClass('error');
    });

    // opens navigation
    $document.on('click', '#bars', function(){
       $navigation.addClass('show');
        // if mobile layout
        if (windowWidth < 641) {
            $navigation.addClass('show-mobile');
            mobileNavigationOpened = true;
        }
    });

    // closes navigation on mobile layout
    $document.on('click', '.js-close-navigation', function(){
        $navigation.removeClass('show-mobile');
        mobileNavigationOpened = false;
    });

    // call animated scrolling
    $document.on('click', '#nav ul a', function(e){
        // prevent page scroll top
        e.preventDefault();
        // scroll
        goToElement($(this).attr('href').replace('#',''));

        // if mobile layout - closes navigation
        $navigation.removeClass('show-mobile');
        mobileNavigationOpened = false;
    });

    // scroll to "About" on "Scroll down" arrow click
    $document.on('click', '#arrow:not(.hidden)', function(e){
        $bodyHtml.animate({scrollTop: windowHeight}, 600);
        $(this).addClass('hidden');
        scrollDownArrowVisible = false;
    });



    // validates contact form and if it is valid - send email
    $document.on('submit','#contact-form',function(e){

        e.preventDefault();

        var valid = true;
        // validating name field
        if (!$('[name="name"]').val()) {
            valid = false;
            $('[name="name"]').focus().addClass('error');
        }
        // validating email field
        if (!$('[name="email"]').val() || !validateEmail($('[name="email"]').val())) {
            if (valid) {
                $('[name="email"]').focus().addClass('error');
            } else {
                $('[name="email"]').addClass('error');
            }
            valid = false;
        }
        // validating message field
        if ($('[name="message"]').val() === '') {
            if (valid) {
                $('[name="message"]').focus().addClass('error');
            } else {
                $('[name="message"]').addClass('error');
            }
            valid = false;
        }
        if (valid) {

            // hide form (visitor must feel instant feedback on form submit)
            $('#contact-form').addClass('hidden').slideUp(300);

            // send email
            $.ajax({
                type: "POST",
                  url: 'send.php',
                  data: $('#contact-form').serializeArray(),
                  dataType: 'text',
                  success: function(data) {
                      // show message
                      if (data == '1') {
                          $('.js-success-message').slideDown(300);
                      } else {
                          $('.js-failure-message').slideDown(300);
                      }
                  }
            });
        }
        return false;
    });

    // checks if email is valid
    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    // 1. moves navigation (per pixel) when scrolling from header to about section
    // 2. removes scroll arrow when first scroll fired (after page loaded)
    // 3. checks wich navigation iten should be active at this moment
    function onScroll() {
            // current scroll position
        var y = $window.scrollTop(),
            // part of header that should be visible at the moment when navigation
            // is fully revealed
            offset = 100,
            l;

        // calculates part of navigation that should be visible at this moment
        if (y < windowHeight - offset && y > windowHeight / 2) {

            var path = windowHeight / 2 - offset,
                move = y - windowHeight / 2;
            l = (navigationWidth / path * move) - navigationWidth;

        } else if (y >= windowHeight - offset) {

            l = 0;

        } else {

            l = -navigationWidth;

        }

        // moves navigation element
        translateX($navigation,l);
        translateX($sections,l/2);

        // removes class that forces full view of navigation
        if (prev > y && y <= windowHeight - offset && y > windowHeight/2) {

            $navigation.removeClass('show');

        }

        // saves current scroll position to detect scrolling direction in the future
        prev = y;

        // if visitor is scrolling and "Scroll down" arrow is visible - hide it
        if (scrollDownArrowVisible && pageIsLoaded) {
            $('#arrow').addClass('hidden');
            scrollDownArrowVisible = false;
        }

        // if visitor scrolled to the top show arrow
        if (!scrollDownArrowVisible && pageIsLoaded && y < 100) {
            $('#arrow').removeClass('hidden');
            scrollDownArrowVisible = true;
        }

        // check navigation links
        $navigationLinks.removeClass('active');
        for (var i = 0; i < pagePartPositions.length; i++) {
            if (y < pagePartPositions[i] - offsetNavigation) {
                $navigationLinks.eq(i-1).addClass('active');
                break;
            }
        }
    }

    // moves element horizontally
    function translateX(elm, value) {
        var translate = 'translateX(' + value + 'px)';
        elm.css({
            '-webkit-transform':translate,
            '-moz-transform':translate,
            '-ms-transform':translate,
            '-o-transform':translate,
        });
    }

    // helper function wich do not allow to execute some function too often
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
  // !function(a,b){"function"==typeof define&&define.amd?define(["jquery"],b):b("object"==typeof exports?require("jquery"):a.jQuery)}(this,function(a){"use strict";function b(a){var b,c,d,e,f,g,h,i={};for(f=a.replace(/\s*:\s*/g,":").replace(/\s*,\s*/g,",").split(","),h=0,g=f.length;g>h&&(c=f[h],-1===c.search(/^(http|https|ftp):\/\//)&&-1!==c.search(":"));h++)b=c.indexOf(":"),d=c.substring(0,b),e=c.substring(b+1),e||(e=void 0),"string"==typeof e&&(e="true"===e||("false"===e?!1:e)),"string"==typeof e&&(e=isNaN(e)?e:+e),i[d]=e;return null==d&&null==e?a:i}function c(a){a=""+a;var b,c,d,e=a.split(/\s+/),f="50%",g="50%";for(d=0,b=e.length;b>d;d++)c=e[d],"left"===c?f="0%":"right"===c?f="100%":"top"===c?g="0%":"bottom"===c?g="100%":"center"===c?0===d?f="50%":g="50%":0===d?f=c:g=c;return{x:f,y:g}}function d(b,c){var d=function(){c(this.src)};a('<img src="'+b+'.gif">').load(d),a('<img src="'+b+'.jpg">').load(d),a('<img src="'+b+'.jpeg">').load(d),a('<img src="'+b+'.png">').load(d)}function e(c,d,e){if(this.$element=a(c),"string"==typeof d&&(d=b(d)),e?"string"==typeof e&&(e=b(e)):e={},"string"==typeof d)d=d.replace(/\.\w*$/,"");else if("object"==typeof d)for(var f in d)d.hasOwnProperty(f)&&(d[f]=d[f].replace(/\.\w*$/,""));this.settings=a.extend({},g,e),this.path=d;try{this.init()}catch(i){if(i.message!==h)throw i}}var f="vide",g={volume:1,playbackRate:1,muted:!0,loop:!0,autoplay:!0,position:"50% 50%",posterType:"detect",resizing:!0,bgColor:"transparent",className:""},h="Not implemented";e.prototype.init=function(){var b,e,g=this,i=g.path,j=i,k="",l=g.$element,m=g.settings,n=c(m.position),o=m.posterType;e=g.$wrapper=a("<div>").addClass(m.className).css({position:"absolute","z-index":-1,top:0,left:0,bottom:0,right:0,overflow:"hidden","-webkit-background-size":"cover","-moz-background-size":"cover","-o-background-size":"cover","background-size":"cover","background-color":m.bgColor,"background-repeat":"no-repeat","background-position":n.x+" "+n.y}),"object"==typeof i&&(i.poster?j=i.poster:i.mp4?j=i.mp4:i.webm?j=i.webm:i.ogv&&(j=i.ogv)),"detect"===o?d(j,function(a){e.css("background-image","url("+a+")")}):"none"!==o&&e.css("background-image","url("+j+"."+o+")"),"static"===l.css("position")&&l.css("position","relative"),l.prepend(e),"object"==typeof i?(i.mp4&&(k+='<source src="'+i.mp4+'.mp4" type="video/mp4">'),i.webm&&(k+='<source src="'+i.webm+'.webm" type="video/webm">'),i.ogv&&(k+='<source src="'+i.ogv+'.ogv" type="video/ogg">'),b=g.$video=a("<video>"+k+"</video>")):b=g.$video=a('<video><source src="'+i+'.mp4" type="video/mp4"><source src="'+i+'.webm" type="video/webm"><source src="'+i+'.ogv" type="video/ogg"></video>');try{b.prop({autoplay:m.autoplay,loop:m.loop,volume:m.volume,muted:m.muted,defaultMuted:m.muted,playbackRate:m.playbackRate,defaultPlaybackRate:m.playbackRate})}catch(p){throw new Error(h)}b.css({margin:"auto",position:"absolute","z-index":-1,top:n.y,left:n.x,"-webkit-transform":"translate(-"+n.x+", -"+n.y+")","-ms-transform":"translate(-"+n.x+", -"+n.y+")","-moz-transform":"translate(-"+n.x+", -"+n.y+")",transform:"translate(-"+n.x+", -"+n.y+")",visibility:"hidden",opacity:0}).one("canplaythrough."+f,function(){g.resize()}).one("playing."+f,function(){b.css({visibility:"visible",opacity:1}),e.css("background-image","none")}),l.on("resize."+f,function(){m.resizing&&g.resize()}),e.append(b)},e.prototype.getVideoObject=function(){return this.$video[0]},e.prototype.resize=function(){if(this.$video){var a=this.$wrapper,b=this.$video,c=b[0],d=c.videoHeight,e=c.videoWidth,f=a.height(),g=a.width();g/e>f/d?b.css({width:g+2,height:"auto"}):b.css({width:"auto",height:f+2})}},e.prototype.destroy=function(){delete a[f].lookup[this.index],this.$video&&this.$video.off(f),this.$element.off(f).removeData(f),this.$wrapper.remove()},a[f]={lookup:[]},a.fn[f]=function(b,c){var d;return this.each(function(){d=a.data(this,f),d&&d.destroy(),d=new e(this,b,c),d.index=a[f].lookup.push(d)-1,a.data(this,f,d)}),this},a(document).ready(function(){var b=a(window);b.on("resize."+f,function(){for(var b,c=a[f].lookup.length,d=0;c>d;d++)b=a[f].lookup[d],b&&b.settings.resizing&&b.resize()}),b.on("unload."+f,function(){return!1}),a(document).find("[data-"+f+"-bg]").each(function(b,c){var d=a(c),e=d.data(f+"-options"),g=d.data(f+"-bg");d[f](g,e)})})});

  function openFullScreenVideo() {
        var videoEl = $('#fullscreen-video'),
            videoElPlayer = $('#fullscreen-video > div');

        if (videoEl.length && videoEl.attr('data-video')) {

            videoElPlayer.vide({
                mp4: videoEl.attr('data-video'),
            }, {
                volume: 1,
                playbackRate: 1,
                muted: false,
                loop: true,
                autoplay: true,
                position: '0 0', // Similar to the CSS `background-position` property.
                posterType: 'none', // Poster image type. "detect" — auto-detection; "none" — no poster; "jpg", "png", "gif",... - extensions.
                resizing: true, // Auto-resizing, read: https://github.com/VodkaBears/Vide#resizing
                bgColor: 'transparent', // Allow custom background-color for Vide div,
                className: ''
            });

            // shows video background, video and fades in volume
            // (looks better when background fades in first and then fades in video)
            videoEl.find('video').hide().attr('controls','').animate({volume: 0},0)
                .animate({volume: 1},600);
            videoEl.fadeIn(300,function(){
                $(this).find('video').fadeIn(300);
            });

        }
    }

    // closes video
    function closeFullScreenVideo() {
        var videoEl = $('#fullscreen-video');

        // animate volume to 0
        videoEl.find('video').animate({volume: 0},600);
        // looks better when video fades out first and then fades out background
        videoEl.find('video').fadeOut(300,function(){
            videoEl.fadeOut(300,function(){
                videoEl.find('video').remove();
            });
        });
    }

    // center "about" element
    function fixAboutSection() {
        var el = $('.section-about > div:last-child');
        el.css({marginTop: '-' + el.outerHeight() / 2 + 'px' });
    }

    // animated scrolling
    function goToElement(id) {
        // make calculations
        var currentScroll = $window.scrollTop(),
            $scrollToElement = $('#'+id),
            // fallback to top of the page if anchor element is missing
            elementPosition = $scrollToElement.length ?
                $scrollToElement.offset().top : 0,
            distanceToElement = Math.abs(currentScroll - elementPosition),
            scrollTime = distanceToElement / 2;

        // make scroll
        $bodyHtml.animate({scrollTop: elementPosition}, scrollTime);

    }

    function checkPagePartPositions() {
        // reset previous data
        pagePartPositions = [];

        // get and save part position by the anchor of each navigation link
        $navigationLinks.each(function(){

            var selector = $(this).attr('href'),
                position = $(selector).offset().top;

            pagePartPositions.push(position);
        });

        // one faked for last part of the page
        pagePartPositions.push(pagePartPositions[pagePartPositions.length-1]+1000);

    }

}())



// WEBPACK FOOTER //
// ./src/assets/js/app.js